/* app/js/src/components/channel/channel-json-editor/channel-json-editor.component.scss */
.container .body .buttons {
  text-align: right;
}
.container .body .buttons ichannel-button {
  margin-left: 10px;
}
.container .body .hasErrors {
  border: 1px solid red;
  outline-color: red;
}
/*# sourceMappingURL=channel-json-editor.component.css.map */
